module.exports = __webpack_public_path__ + "img/tzav_no.88cfc3f2.png";